<template>  
    <modal v-model="show"
           max-width="400"
           :has-padding="false">         
  
      <Form @submit="validate()">
          <ConnectionsMacRegisterModalFormBody ref="body"
                             v-model="data"
                             :isEdit="isEdit"
                             @input="input"
                             @valid="save"></ConnectionsMacRegisterModalFormBody>
          <div class="card-footer">
              <button class="btn btn-primary btn-round" type="submit">
                  {{$t('message.generics.message.save')}}
              </button>
          </div>
      </Form>
    </modal>   
  </template>
  
  <script>
    import ConnectionsMacRegisterModalFormBody from './components/ConnectionsMacRegisterModalFormBody.vue';
    import EventBus from '@packages/event-bus/index'
    import Modal from "@/components/generic/Modal";
    import Form from '../../../../../components/form/Form.vue';

    export default {
        components: {
            ConnectionsMacRegisterModalFormBody,
            Modal,
            Form
        },

        data() {
            return {
                show: false,
                data : {},
                isEdit: false
            }
        },

        props: {
            dataActivatorText: {
                type: String,
                required: true
            }
        },

        computed: {
        },

        methods: {
            input(value) {
                this.data = value
            },
            reset(){
                this.show = true
                this.isEdit = false
                this.data = {}
            },
            setInitialData(item){
                this.show = true
                this.isEdit = true
                this.data = {
                mac: item.macAddress,
                action: item.action
                }
            },
            validate() {
                this.$refs.body.validate()
            },
            async save() {
                if(!this.data.action) {
                    return EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: "Selecione uma ação"
                    });
                }
                if (this.isEdit) {
                    await this.$api.macAddresses.update(this.data)
                    EventBus.$emit("show-message", {
                        type: "SUCCESS",
                        message: "Endereço MAC atualizado com sucesso"
                    });
                } else {
                    await this.$api.macAddresses.create(this.data)
                    EventBus.$emit("show-message", {
                        type: "SUCCESS",
                        message: "Endereço MAC cadastrado com sucesso"
                    });
                }
                this.$emit("changed")
                this.show = false
            },

        },
        mounted() {
            EventBus.$on('REGISTER_MAC', this.reset)
            EventBus.$on('EDIT_ITEM', this.setInitialData)
        },
        beforeDestroy() {
            EventBus.$off('REGISTER_MAC', this.reset)
            EventBus.$off('EDIT_ITEM', this.setInitialData)
        },
    }
  </script>
  
  <style lang="scss" scoped>
  
      .card-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-bottom: 15px;
  
          .btn {
              margin: 15px;
          }
      }
  
      .modal-round .v-card .card-body {
          min-height: 160px;
      }
  </style>
  